import PropTypes from "prop-types";

export default function ImageLoadingType() {
  return PropTypes.oneOf(ImageLoadingType.values);
}

ImageLoadingType.values = ["eager", "lazy"];
